import React from 'react';
export function TablePageShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-15244">
      <span className="sr-only" data-id="element-15245">Loading table…</span>
      {/* Header with button */}
      <div className="flex justify-between items-center" data-id="element-15246">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-15247" />
        <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-15248" />
      </div>
      {/* Stats cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-15249">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-15250">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-15251" />
            <div className="h-8 w-32 bg-gray-200 rounded mb-2" data-id="element-15252" />
            <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-15253" />
          </div>)}
      </div>
      {/* Table */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-15254">
        {/* Table header */}
        <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-15255">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-15256" />
          <div className="h-10 w-64 bg-gray-200 rounded-md" data-id="element-15257" />
        </div>
        {/* Table content */}
        <div className="overflow-x-auto" data-id="element-15258">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-15259">
            <thead data-id="element-15260">
              <tr data-id="element-15261">
                {[1, 2, 3, 4, 5].map(i => <th key={i} className="px-4 py-3" data-id="element-15262">
                    <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-15263" />
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-15264">
              {[1, 2, 3, 4, 5, 6, 7, 8].map(i => <tr key={i} data-id="element-15265">
                  {[1, 2, 3, 4, 5].map(j => <td key={j} className="px-4 py-4" data-id="element-15266">
                      <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-15267" />
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="p-4 border-t border-gray-200 flex justify-between items-center" data-id="element-15268">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-15269" />
          <div className="flex gap-2" data-id="element-15270">
            {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-8 bg-gray-200 rounded" data-id="element-15271" />)}
          </div>
        </div>
      </div>
    </div>;
}